import { gql } from "graphql-tag";

export const gamesGQL = gql`
  query Games($input: ListGamesInput!) {
    games(input: $input) {
      total
      items {
        id
        title
        description
        data
        metadata
        developer
        publisher
        category
        rotationMode
        status
        type
        featured
        hasBattle
        hasSolo
        hasTournament
      }
    }
  }
`;

export const gameGQL = gql`
  query Game($gameId: String!) {
    game(id: $gameId) {
      metadata
      title
      type
      status
      orientation
      id
      description
      category
      pegiAge
      pegiContent
      developer
      publisher
    }
  }
`;

export const gamesPackGQL = gql`
  query Games($input: ListGamesInput!) {
    games(input: $input) {
      total
      items {
        id
        title
        description
        category
        metadata
        orientation
        status
        type
        pegiAge
        pegiContent
        developer
        publisher
      }
    }
  }
`;

export const gameSessionGql = gql`
  query GameSession($input: GameSessionInput!) {
    gameSession(input: $input) {
      id
      status
      launchData {
        ... on CasualHtmlLaunchData {
          __typename
          gameConfig
          launchUrl
        }
        ... on N2IStreamLaunchData {
          __typename
          launchUrl
          sessionId
        }
        ... on PCStreamLaunchData {
          __typename
          launchUrl
          streamStatusUrl
        }
        ... on BlacknutStreamLaunchData {
          __typename
          accessToken
          blacknutGameId
          refreshToken
        }
      }
    }
  }
`;
